import { createAxios } from "../config/axios";

const checkConfirmPayment = async (deliveryCode: string): Promise<boolean> =>
  createAxios().get("b2b_delivery/check_confirm/" + deliveryCode);

export const deliveryService = {
  checkConfirmPayment,
};
